module.exports = {
  "star": {
    "flexDirection": "row",
    "justifyContent": "space-between"
  },
  "star-big": {
    "width": "416"
  },
  "star-mid": {
    "width": "392"
  },
  "star-small": {
    "width": "176"
  },
  "iconfont": {
    "position": "relative",
    "fontSize": "36"
  },
  "iconfont-big": {
    "width": "64",
    "height": "64"
  },
  "iconfont-mid": {
    "width": "56",
    "height": "56"
  },
  "iconfont-small": {
    "width": "32",
    "height": "32"
  },
  "star-img-big": {
    "width": "64",
    "height": "64"
  },
  "star-img-mid": {
    "width": "56",
    "height": "56"
  },
  "star-img-small": {
    "width": "32",
    "height": "32"
  },
  "left": {
    "position": "absolute",
    "left": 0,
    "top": 0
  },
  "left-big": {
    "width": "32",
    "height": "64"
  },
  "left-mid": {
    "width": "28",
    "height": "56"
  },
  "left-small": {
    "width": "16",
    "height": "32"
  },
  "right": {
    "position": "absolute",
    "top": 0
  },
  "right-big": {
    "width": "32",
    "height": "64",
    "left": "32"
  },
  "right-mid": {
    "width": "28",
    "height": "56",
    "left": "28"
  },
  "right-small": {
    "width": "16",
    "height": "32",
    "left": "16"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-cb6ef50e!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-rate/index.vue
// module id = 538
// module chunks = 0 1